import { createSelector } from '@reduxjs/toolkit';

import { getLoggedInUser } from '@paragon/login-tools';

const ORGANIZATIONS_WITH_PARAPET_LOADS = [
  'G2 National',
  'Paragon Component Systems',
  'DrJ Engineering',
  'Develop Organization A',
];

export const canCurrentUserSeeParapetLoads = createSelector(getLoggedInUser, (user) => {
  if (!user) {
    return false;
  }

  return ORGANIZATIONS_WITH_PARAPET_LOADS.includes(user.organization);
});
